import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { faHeart as faHeartO } from "@fortawesome/free-regular-svg-icons";
import { faCartShopping, faShareNodes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { formatImageUrl } from "../../_helpers/format-image-url";
import { UseCartList } from "../../services/cart/cart.context";

export const ItemCard = ({ item, addToList, wishList, openCart }) => {

    const navigateTo = useNavigate();

    const handleAdd = (item) => {
        addToList(item);
    }


    return (
        <div
            className="item-card-container"
            style={{
                backgroundImage: `url("${formatImageUrl(item.images[0])}")`
            }}
        >
            <span className="action-buttons">
                <button
                    onClick={ addToList }
                >
                    <FontAwesomeIcon
                        className="list-icon"
                        icon={
                            wishList?.some((obj) => obj?._id === item._id) ? faHeart : faHeartO

                        }
                        color={wishList?.some((obj) => obj?._id === item._id) ? 
                            '#f0000f' : "#ffffff"
                        }
                    />
                </button>

                <button
                    onClick={() => openCart(item)}
                >
                    <FontAwesomeIcon
                        className="action-icon"
                        icon={faCartShopping}
                    />
                </button>
                <button
                    onClick={() => alert('share!')}
                >
                    <FontAwesomeIcon
                        className="action-icon"
                        icon={faShareNodes}
                    />
                </button>
            </span>
            <button
                className="card-bg"
                onClick={() => navigateTo("/details", { state: { car: item } })}
            >
                <span className="item-data">
                    <span className="data-unit br">{item?.brand}</span>
                    <span className="data-group">
                        <span className="data-unit  nm">{item?.model}</span>
                        <span className="data-unit nm">{item?.year}</span>
                    </span>
                    <span className="data-unit pr">FCFA {(item?.cost).toLocaleString()}</span>
                </span>

            </button>
        </div>
    );
}